import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {first} from 'rxjs/operators';
import {AlertService, UserService} from '@app/_services';
import {AutoComplete} from 'primeng/autocomplete';

@Component({
    selector: 'app-user-search',
    templateUrl: './user-search.component.html',
    styleUrls: ['./user-search.component.css'],
    standalone: false
})
export class UserSearchComponent implements OnInit, OnChanges, AfterViewInit
{
  @Input() selectedUser: any;
  users: any[] = [];
  @Output() onUserSelected = new EventEmitter<any>();
  @Output() onUserClearedEvent = new EventEmitter<any>();
  @Input() showCreateUser = true;
  @Input() forSearchBar = false;
  @ViewChild('userautocom') autocomplete: AutoComplete;
  constructor(private userService: UserService,
              private alertService: AlertService) {
  }
  ngAfterViewInit(): void {
  }
  
  focusInput() {
    if (this.autocomplete && this.autocomplete.inputEL) {
      setTimeout(() => {
        this.autocomplete.inputEL.nativeElement.focus();
      }, 100);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.reflectFullName();
  }

  ngOnInit(): void {
    this.reflectFullName();
  }
  reflectFullName(){
    if (this.selectedUser && ( this.selectedUser?.lastName || this.selectedUser?.firstName)){
      // Display only name without ID
      const nameParts = [];
      if (this.selectedUser?.lastName) nameParts.push(this.selectedUser.lastName);
      if (this.selectedUser?.firstName) nameParts.push(this.selectedUser.firstName);
      this.selectedUser.fullName = nameParts.join(' ').trim();
    }
  }
  onKeyInput(event)
  {
    let query = event.query;
    this.findUsersWith(query);
    return this.users;
  }

  findUsersWith(queryString: string)
  {
    this.userService.findUsersWith(queryString).pipe(first()).subscribe(

      data =>
      {
        console.log('taskUser serach: ' + JSON.stringify(data));
        this.users = [];
        this.users = data.data.userSummaryList;
        this.users.forEach(user => {
          if ( !user.lastName) { user.lastName = ''; }
          if ( !user.firstName) { user.firstName = ''; }
          user.fullName = user.lastName + ' ' + user.firstName + ' ' + user.emailAddress + ' ' + user.userId;
        });
        // console.log('QA: ' + JSON.stringify(this.taskUserSuggestions));
      },
      error =>
      {
        // console.log('reports LIST!: ' + JSON.stringify(error));
        this.alertService.error(error);
      },
      () =>
      { }
    );
  }
  userInfo(event: any){
    this.selectedUser = event;
  }

  onUserSeleted(user: any) {
    this.selectedUser = user;
    // Update fullName to show only name without ID for display
    if (this.selectedUser) {
      const nameParts = [];
      if (this.selectedUser?.lastName) nameParts.push(this.selectedUser.lastName);
      if (this.selectedUser?.firstName) nameParts.push(this.selectedUser.firstName);
      this.selectedUser.fullName = nameParts.join(' ').trim();
    }
    this.emitUserSelected();
  }
  onUserCleared(user: any) {
    this.selectedUser = null;
    this.onUserClearedEvent.emit(this.selectedUser);
  }
  emitUserSelected(){
    if (this.selectedUser){
      this.onUserSelected.emit(this.selectedUser);
    }
  }
}
